import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectJournalEntries } from '../../../store/journal/journal.state';
import { Action } from '../../../models/action';
import { map } from 'rxjs/operators';
import { MatLine } from '@angular/material/core';
import { IconComponent } from '../../shared/icon/icon.component';
import { AsyncPipe, DatePipe } from '@angular/common';
import { MatList, MatListItem } from '@angular/material/list';

@Component({
    selector: 'app-journal',
    templateUrl: './journal.component.html',
    styleUrls: ['./journal.component.scss'],
    imports: [MatList, MatListItem, IconComponent, MatLine, AsyncPipe, DatePipe]
})
export class JournalComponent implements OnInit {

    entries$: Observable<Action[]>;

    constructor(private store: Store<AppState>) {
        this.entries$ = this.store.select(selectJournalEntries).pipe(
            map((actions) => [...actions].sort((a, b) => b.uid.localeCompare(a.uid)))
        );
    }

    ngOnInit(): void {
    }

}
